import React from 'react';
import { Table, Modal } from 'antd';
import { TemplateTypeEnum } from '../../types/enums';

export const showVariableList = (templateType) => {

  const visitTemplateVariables = [
    { variable: 'name', description: 'Medication Name' },
    { variable: 'quantity', description: 'Medication Quantity' },
    { variable: 'quantityUnits', description: 'Medication Quantity Units' },
    { variable: 'daysSupply', description: 'Prescription Days Supply' },
    { variable: 'refills', description: 'Prescription Refills' },
    { variable: 'strength', description: 'Medication Strength' },
  ]

  const templateVariables = [
    { variable: 'case._id', description: 'Case ID' },
    { variable: 'patient.firstName', description: "Patient's First Name" },
    { variable: 'patient.lastName', description: "Patient's Last Name" },
    { variable: 'physician.firstName', description: "Assigned Physician's First Name" },
    { variable: 'physician.lastName', description: "Assigned Physician's Last Name" },
  ]

  const isVisit = templateType === TemplateTypeEnum.VISIT

  const renderTemplateVariables = () => {
    if (isVisit) {
      return visitTemplateVariables
    }
    return templateVariables
  }

  const renderExample = () => {
    if (isVisit) {
      return (
        <>
          <p>Example: Administer <em><strong>&#123;&#123;quantity&#125;&#125; &#123;&#123;quantityUnits&#125;&#125; &#123;&#123;name&#125;&#125;</strong></em> for 30 days.</p>
          <p>Result: Administer <em><strong>30 mL Testosterone Cypionate</strong></em> for 30 days.</p>
        </>
      )
    }
    return (
      <>
        <p>Example: Hello <em><strong>&#123;&#123;patient.firstName&#125;&#125; &#123;&#123;patient.lastName&#125;&#125;</strong></em></p>
        <p>Result: Hello <em><strong>John Doe</strong></em></p>
      </>
    )
  }

  return (
    Modal.info({
      title: 'Template Variables',
      centered: true,
      maskClosable: true,
      icon: null,
      width: '50vw',
      content: (
        <>
          <div style={{ marginBottom: 20 }}>
            <p style={{ marginBottom: 30 }}>Add variables to templates by wrapping them with two sets of curly braces.</p>
            {renderExample()}
          </div>
          <Table
            columns={[
              { dataIndex: 'variable', title: 'Variable' },
              { dataIndex: 'description', title: 'Description' },
            ]}
            pagination={false}
            dataSource={renderTemplateVariables()}
          />
        </>
      )
     })
  )
}